import { Box } from "@mui/material";
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
import IDMELogo from "../../../images/icons/IDme.svg";
import DigitalRxLogo from "../../../images/icons/DRxLogo.svg";
import WarningAmberOutlined from "@mui/icons-material/WarningAmberOutlined";

export default function InvalidCode() {
  return (
    <>
      <Grid container spacing={2} height={400}>
        <Grid item xs={12}>
          <Box className="logos">
            <img src={IDMELogo} alt="ID.me" height={30} />
            <Typography
              component={"div"}
              color={"slategrey"}
              variant={"h3"}
              fontWeight={600}
            >
              +
            </Typography>
            <img src={DigitalRxLogo} alt="Digital Rx" height={30} />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <Typography
              variant={"subtitle1"}
              fontWeight={500}
              textAlign="center"
              width={"29rem"}
              bgcolor={"#FFC0CB"}
              padding={2}
              borderRadius={1}
            >
              Unable to complete your request
            </Typography>
          </Box>
          <Box
            display={"flex"}
            gap={1}
            alignItems={"center"}
            justifyContent={"center"}
            margin={2}
          >
            <WarningAmberOutlined fontSize="medium" color="warning" />
            <Typography variant={"subtitle1"} fontWeight={500}>
              Too many failed attempts, please try again for completing
              two-factor authentication.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
